export default __webpack_public_path__ + "static/media/wood2.729031c5.jpg";